<template>
  <svg
    
    viewBox="0 0 282 224"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="281"
      height="222.773"
      rx="6.5"
      fill="white"
      stroke="#CACACD"
      stroke-dasharray="5 5"
    />
    <g opacity="0.5" clip-path="url(#clip0_1533_61905)">
      <path
        d="M169.684 93.3342H159.581L153.748 86.9597H134.624V93.3342H150.943L156.776 99.7087H169.684V137.956H118.688V109.27H112.314V137.956C112.314 141.462 115.182 144.33 118.688 144.33H169.684C173.19 144.33 176.059 141.462 176.059 137.956V99.7087C176.059 96.2027 173.19 93.3342 169.684 93.3342ZM128.25 118.832C128.25 127.629 135.389 134.768 144.186 134.768C152.983 134.768 160.122 127.629 160.122 118.832C160.122 110.035 152.983 102.896 144.186 102.896C135.389 102.896 128.25 110.035 128.25 118.832ZM144.186 109.27C149.445 109.27 153.748 113.573 153.748 118.832C153.748 124.091 149.445 128.394 144.186 128.394C138.927 128.394 134.624 124.091 134.624 118.832C134.624 113.573 138.927 109.27 144.186 109.27ZM118.688 93.3342H128.25V86.9597H118.688V77.3979H112.314V86.9597H102.752V93.3342H112.314V102.896H118.688V93.3342Z"
        fill="#080816"
        fill-opacity="0.38"
      />
    </g>
    <defs>
      <clipPath id="clip0_1533_61905">
        <rect
          width="76.4939"
          height="76.4939"
          fill="white"
          transform="translate(102.752 74.2104)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
    name  : "CameraBorderBoxSvg"
}
</script>
